// removed by extract-text-webpack-plugin
module.exports = {"block":"_2dPwmXgOrLoefOs6lvVguF","heading":"_2JlMyMruKfktnAo6LYu8GB","list":"_2XaSq7EPMZghKZ7TpnldFm","link":"_24qHR4ufEp8sGz-GQUYqLw","listItem":"_1d4Vl1tMDU9SPbo2qmL8NO"};


//////////////////
// WEBPACK FOOTER
// ./src/components/GroupWithLinksBlock/GroupWithLinksBlock.module.scss
// module id = 771
// module chunks = 0